'use client';

import { type ReactElement } from 'react';

import PdpTemplate from '../shared';
import { signatureSections } from './sections';

import type { SignatureProductDetailData } from './types';
import { PdpBreadcrumb, ProductDetailProperty, ProductDetailStores } from '../shared/types';

export type Props = {
	product: SignatureProductDetailData;
	className?: string;
	property: ProductDetailProperty;
	breadcrumb?: PdpBreadcrumb;
} & ProductDetailStores;

export default function SignatureProductDetailPage({
	product,
	className = '',
	userStore,
	globalStore,
	cartStore,
	productAvailabilityStore,
	bookingsStore,
	property,
	breadcrumb,
}: Props): ReactElement | null {
	return (
		<PdpTemplate
			product={product}
			enhancementMerchA="signature"
			sections={signatureSections(
				product,
				{
					userStore,
					globalStore,
					productAvailabilityStore,
					bookingsStore,
					cartStore,
				},
				breadcrumb?.items
			)}
			className={className}
			stores={{
				userStore,
				bookingsStore,
				globalStore,
				cartStore,
				productAvailabilityStore,
			}}
			property={property}
		/>
	);
}
